import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';


@Injectable({
  providedIn: 'root'
})

export class MunicipioService {

  getMunicipio(itemId: any): Observable<HttpResponse<any>> {
    return this.http.get(
      `${environment.apiSaguiControl}/api/municipio/visualiza/`+ itemId, { observe: 'response' })
    .pipe(
      catchError(this.handleError)
    );
  }

  getMunicipioPorUf(ufId: any): Observable<HttpResponse<any>> {
    return this.http.get(
      `${environment.apiSaguiControl}/api/municipio/buscaporuf/`+ ufId, { observe: 'response' })
    .pipe(
      catchError(this.handleError)
    );
  }

  // getTodosOsMunicipios(ufId: any): Observable<HttpResponse<any>> {
  //   return this.http.get(
  //     `${environment.apiSaguiControl}/api/municipio/buscaporuf/`+ ufId, { observe: 'response' })
  //   .pipe(
  //     catchError(this.handleError)
  //   );
  // }

  constructor(private http: HttpClient, private sanitizer: DomSanitizer) {

    }private handleError(error: HttpErrorResponse) {
    let errorMessage = 'Erro desconhecido';

    if (error.error instanceof ErrorEvent) {
      // Erro do lado do cliente
      errorMessage = `Erro: ${error.error.message}`;
    } else {
      // Erro do lado do servidor
      errorMessage = `Código: ${error.status}\nMensagem: ${error.message}`;
    }

    console.error(errorMessage);
    return throwError(() => new Error(errorMessage))
  }
}
